import PublicationListSelectionSlide from "./PublicationListSelectionSlide";

export default PublicationListSelectionSlide;
